const Resources = {

    table_headers: [
        { 
            text:   'Task',
            value: 'name',
        },
        { 

            text:   'Description',
            value: 'description',
        },
        { 

            text:   'Frequency',
            value: 'frequency_id',
            type:  'select',
        },
    ],
    
    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Options',
            href:   '#',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Default Project Codes',
            href:   '/options-default-project-codes',
            arrow:  "",
        },
    ],

    excel_file_headers:  
    {
        'Floor type': 'Floor type',
        'Daily task': 'Daily task',
        'Task': 'Task',
        'Frequency': 'Frequency',
    },

    empty_format_data: 
    [
        {
            'Floor type': '',
            'Daily task': '',
            'Task': '',
            'Frequency': ''
        }
    ],

}

export default Resources;